import Cookie from 'js-cookie';
import Store from '@/store';
import * as jwt from 'jsonwebtoken';
import moment from 'moment';

/**
 * 저장할 공간
 *
 * @var sessionStorage window.sessionStorage
 * @var localStorage window.localStorage
 * @var cookie document.cookie
 */
// const STORE_TYPE = 'cookie';
const STORE_TYPE = 'localStorage';

const TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

const getTimestampFromToken = token => {
	const decoded = jwt.decode(token);
	if (decoded?.expireDate)
		return moment(`${decoded?.expireDate} +09:00`, 'YYYY-MM-DD HH:mm:ss Z').toDate().getTime() / 1000;

	return;
};

const getExpiresIn = token => {
	const expiration = getTimestampFromToken(token);
	if (!expiration) return -1;
	return expiration - Date.now() / 1000;
};

const isValidToken = token => !!(token && jwt.decode(token));

const getStorage = () => {
	if (STORE_TYPE === 'sessionStorage') return window.sessionStorage;
	if (STORE_TYPE === 'localStorage') return window.localStorage;
	if (STORE_TYPE === 'cookie')
		return {
			setItem: Cookie.set,
			getItem: Cookie.get,
			removeItem: Cookie.remove,
		};
};

const set = ({ accessToken, refreshToken }) => {
	const storage = getStorage();
	if (isValidToken(accessToken)) {
		storage.setItem(TOKEN_KEY, accessToken);
		Store.commit('SET_TOKEN', accessToken);
	}
	if (isValidToken(refreshToken)) {
		storage.setItem(REFRESH_TOKEN_KEY, refreshToken);
		Store.commit('SET_REFRESH_TOKEN', refreshToken);
	}
};

const get = () => {
	const storage = getStorage();
	const accessToken = storage.getItem(TOKEN_KEY);
	const refreshToken = storage.getItem(REFRESH_TOKEN_KEY);
	return {
		accessToken: isValidToken(accessToken) ? accessToken : undefined,
		refreshToken: isValidToken(refreshToken) ? refreshToken : undefined,
	};
};

const clear = () => {
	const storage = getStorage();
	storage.removeItem(TOKEN_KEY);
	storage.removeItem(REFRESH_TOKEN_KEY);
	Store.commit('SET_TOKEN');
	Store.commit('SET_REFRESH_TOKEN');
};

const getDecodedToken = () => {
	return {
		accessToken: jwt.decode(get().accessToken),
		refreshToken: jwt.decode(get().refreshToken),
	};
};

const init = () => {
	const accessToken = get().accessToken;
	const refreshToken = get().refreshToken;

	if (!accessToken || !refreshToken) {
		clear();
		return;
	}
	if (getExpiresIn(refreshToken) < 60) {
		clear();
		return;
	}

	set({
		accessToken,
		refreshToken,
	});
};

export default {
	set,
	get,
	clear,
	getDecodedToken,
	init,
};
